import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StringUtil } from 'src/app/utils/string.util';

const routes : Routes = [
  {
    path: StringUtil.EMPTY,
    loadChildren: () => import("./primecap/primecap.module").then(m => m.PrimecapModule)
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DomainRoutes{}